import { render, staticRenderFns } from "./GColorPreview.vue?vue&type=template&id=abc307ce&scoped=true&"
import script from "./GColorPreview.vue?vue&type=script&lang=ts&"
export * from "./GColorPreview.vue?vue&type=script&lang=ts&"
import style0 from "./GColorPreview.vue?vue&type=style&index=0&id=abc307ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc307ce",
  null
  
)

export default component.exports